var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarAppoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 37,
    viewBox: "0 0 39 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5358 9.79932H10.2038C9.40305 9.79932 8.75391 10.4485 8.75391 11.2492V28.1647C8.75391 28.9655 9.40305 29.6146 10.2038 29.6146H29.5358C30.3366 29.6146 30.9857 28.9655 30.9857 28.1647V11.2492C30.9857 10.4485 30.3366 9.79932 29.5358 9.79932Z",
    fill: "#495784"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5358 7.8667H10.2038C9.40305 7.8667 8.75391 8.51584 8.75391 9.3166V26.2321C8.75391 27.0329 9.40305 27.682 10.2038 27.682H29.5358C30.3366 27.682 30.9857 27.0329 30.9857 26.2321V9.3166C30.9857 8.51584 30.3366 7.8667 29.5358 7.8667Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5358 5.93311H10.2038C9.40305 5.93311 8.75391 6.58225 8.75391 7.38301V24.2985C8.75391 25.0993 9.40305 25.7484 10.2038 25.7484H29.5358C30.3366 25.7484 30.9857 25.0993 30.9857 24.2985V7.38301C30.9857 6.58225 30.3366 5.93311 29.5358 5.93311Z",
    fill: "#485582"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1527 25.7484H10.2038C9.81927 25.7484 9.45048 25.5956 9.17857 25.3237C8.90666 25.0518 8.75391 24.683 8.75391 24.2985V7.38301C8.75391 6.99847 8.90666 6.62968 9.17857 6.35777C9.45048 6.08586 9.81927 5.93311 10.2038 5.93311H29.5358C29.9203 5.93311 30.2891 6.08586 30.561 6.35777C30.8329 6.62968 30.9857 6.99847 30.9857 7.38301V20.9154L26.1527 25.7484Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2038 5.93311H29.5358C29.9203 5.93311 30.2891 6.08586 30.561 6.35777C30.8329 6.62968 30.9857 6.99847 30.9857 7.38301V11.2494H8.75391V7.38301C8.75391 6.99847 8.90666 6.62968 9.17857 6.35777C9.45048 6.08586 9.81927 5.93311 10.2038 5.93311Z",
    fill: "#0A74DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1523 25.7485V22.3654C26.1523 21.9809 26.3051 21.6121 26.577 21.3402C26.8489 21.0683 27.2177 20.9155 27.6022 20.9155H30.9853L26.1523 25.7485Z",
    fill: "#EBEBE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5865 4.9666C13.5865 4.43276 13.1538 4 12.6199 4C12.0861 4 11.6533 4.43276 11.6533 4.9666V6.8998C11.6533 7.43364 12.0861 7.8664 12.6199 7.8664C13.1538 7.8664 13.5865 7.43364 13.5865 6.8998V4.9666Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4195 4.9666C18.4195 4.43276 17.9868 4 17.4529 4C16.9191 4 16.4863 4.43276 16.4863 4.9666V6.8998C16.4863 7.43364 16.9191 7.8664 17.4529 7.8664C17.9868 7.8664 18.4195 7.43364 18.4195 6.8998V4.9666Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2525 4.9666C23.2525 4.43276 22.8198 4 22.2859 4C21.7521 4 21.3193 4.43276 21.3193 4.9666V6.8998C21.3193 7.43364 21.7521 7.8664 22.2859 7.8664C22.8198 7.8664 23.2525 7.43364 23.2525 6.8998V4.9666Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0855 4.9666C28.0855 4.43276 27.6528 4 27.1189 4C26.5851 4 26.1523 4.43276 26.1523 4.9666V6.8998C26.1523 7.43364 26.5851 7.8664 27.1189 7.8664C27.6528 7.8664 28.0855 7.43364 28.0855 6.8998V4.9666Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4196 19.4662L15.6653 20.016C14.4705 18.6504 12.8056 17.7842 11.0016 17.5896C9.19753 17.3949 7.38627 17.8861 5.92771 18.9655C4.46915 20.0449 3.47004 21.6335 3.12889 23.4157C2.78774 25.1979 3.12953 27.0431 4.08633 28.5849C5.04314 30.1267 6.54494 31.2521 8.29333 31.7375C10.0417 32.2229 11.9087 32.0328 13.5234 31.2049C15.1381 30.3771 16.3823 28.9721 17.0087 27.2691C17.6351 25.5662 17.598 23.6899 16.9046 22.013L18.4196 19.4662Z",
    fill: "#E8553E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5529 23.3314H11.6531V20.4316H8.75332V23.3314H5.85352V26.2312H8.75332V29.131H11.6531V26.2312H14.5529V23.3314Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2354 13.9604H17.605V15.3484H16.2354V13.9604Z",
    fill: "#495784"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7197 13.9609H14.0894V15.3489H12.7197V13.9609Z",
    fill: "#495784"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2656 13.9604H24.6352V15.3484H23.2656V13.9604Z",
    fill: "#495784"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7812 13.9604H28.1509V15.3484H26.7812V13.9604Z",
    fill: "#495784"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.751 13.9604H21.1206V15.3484H19.751V13.9604Z",
    fill: "#495784"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2354 17.3145H17.605V18.7024H16.2354V17.3145Z",
    fill: "#495784"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2656 17.3145H24.6352V18.7024H23.2656V17.3145Z",
    fill: "#495784"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7812 17.3145H28.1509V18.7024H26.7812V17.3145Z",
    fill: "#495784"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19.751 17.3145H21.1206V18.7024H19.751V17.3145Z",
    fill: "#495784"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2656 20.6685H24.6352V22.0564H23.2656V20.6685Z",
    fill: "#495784"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.751 20.6685H21.1206V22.0564H19.751V20.6685Z",
    fill: "#495784"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.753906,
    y: 0.866699,
    width: 38.2318,
    height: 35.8153,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.196078 0 0 0 0 0.219608 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAppoint);
export default __webpack_public_path__ + "static/media/calendar-appoint.368b4bea6f1dd913919a285d33af455d.svg";
export { ForwardRef as ReactComponent };